import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';
import { questService } from '@/services/quest';
import { useVuelidate } from '@vuelidate/core';
import { integer, maxValue, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useQuestTypeAdd() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        name: '',
        displayType: 0,
        timeUnit: 0,
        timeDuration: '',
        openCycle: null,
        restCycle: null,
        startTime: new Date()
    });

    const validations = {
        name: { required },
        timeDuration: { required, integer, min: minValue(1), max: maxValue(32000) },
        openCycle: { required, integer, min: minValue(1) },
        restCycle: { required, integer, min: minValue(0) },
        startTime: { required }
    };

    const v$ = useVuelidate(validations, model);

    const create = crudAction.excuteAndNotify({
        validator: v$,
        request: () =>
            questService.type.create(
                model.name,
                model.displayType,
                model.timeUnit,
                model.timeDuration,
                model.openCycle,
                model.restCycle,
                model.startTime.getTime()
            ),
        onSuccess: () => router.push({ name: ROUTE_NAME_QUEST.TYPE.INDEX })
    });

    return { model, v$, create };
}
